if (!customElements.get('stock-embroidery-reveal')) {
  customElements.define('stock-embroidery-reveal', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const range = this.querySelector('input[type="range"]');
      const frame = this.querySelector('.stock-embroidery-reveal__frame');
      const buttons = this.querySelectorAll('button[data-position]');
      if (!range || !frame) return;
      const update = (position) => {
        const value = Math.max(0, Math.min(100, Number(position)));
        range.value = String(value);
        this.style.setProperty('--stock-reveal', `${value}%`);
        buttons.forEach((button) => button.setAttribute('aria-pressed', String(Number(button.dataset.position) === value)));
      };
      range.addEventListener('input', () => update(range.value));
      frame.addEventListener('pointermove', (event) => {
        if (event.pointerType !== 'mouse' || event.buttons || document.activeElement === range) return;
        const rect = frame.getBoundingClientRect();
        update(Math.round((event.clientX - rect.left) / rect.width * 100));
      });
      buttons.forEach((button) => button.addEventListener('click', () => update(button.dataset.position)));
      update(range.value);
    }
  });
}
